export { default, loader } from "~/components/footer/Footer"
export { default as LoadingFallback } from "~/components/LoadingFallback"

export const eager = true;
export const sync = true;
